class LinkedListNode {
    prev?: LinkedListNode
    next?: LinkedListNode
    id: number

    constructor(id: number) {
        this.id = id
    }
}

export class LinkedList<K = string> {
    changed: boolean
    index: Record<string, LinkedListNode>
    first?: LinkedListNode
    last?: LinkedListNode
    key: K
    resetLists?: () => void

    constructor(prepopulate: Array<number>, key: K, resetLists?: () => void) {
        this.changed = true
        this.index = {}
        this.key = key
        this.resetLists = resetLists
        if (!prepopulate || !prepopulate[0]) {
            return
        }
        const [first] = prepopulate
        const node = new LinkedListNode(first)
        this.first = this.index[first] = node
        if (prepopulate.length === 1) {
            return
        }
        this.last = prepopulate.slice(1).reduce((prev, current) => {
            const node = new LinkedListNode(current)
            prev.next = node
            node.prev = prev
            return (this.index[current] = node)
        }, node)
    }

    insert(id: number): LinkedListNode {
        this.changed = true
        const node = new LinkedListNode(id)
        this.index[id] = node

        try {
            if (!this.first) {
                this.first = node
                return
            }

            if (!this.last) {
                this.last = node
                this.first.next = this.last
                this.last.prev = this.first
                return
            }

            this.last.next = node
            node.prev = this.last
            this.last = node

            return node
        } catch (error) {
            console.error(error, `LINKED LIST ERROR:`, this.key, id)
            if (this.resetLists) {
                this.resetLists()
            }
            return node
        }
    }

    insertBefore(id: number, existingID: number): LinkedListNode {
        // console.log('\n\n\n')
        // console.log('New ID:', id)
        // console.log('Existing ID:', existingID)
        // console.log('First Node:', this.first)
        // console.log('Last Node:', this.last)
        // console.log('Index:', this.index)
        if (!existingID) {
            // console.log('Tree:', this.first)
            // console.log('\n\n\n')
            return this.insert(id)
        }

        this.changed = true
        const referenceNode = this.index[existingID]
        // console.log('Reference Node:', referenceNode)
        const node = new LinkedListNode(id)

        try {
            this.index[id] = node
            node.next = referenceNode
            node.prev = referenceNode.prev

            if (referenceNode.prev) {
                referenceNode.prev.next = node
            }

            referenceNode.prev = node

            if (!referenceNode.next) {
                this.last = referenceNode
            }

            if (!node.prev) {
                this.first = node
            }
            // console.log('Tree:', this.first)
            // console.log('\n\n\n')
            return node
        } catch (error) {
            console.error(error, `LINKED LIST ERROR:`, this.key, id, existingID)
            if (this.resetLists) {
                this.resetLists()
            }
            return node
        }
    }

    remove(id: number): LinkedListNode {
        this.changed = true
        const node = this.index[id]
        delete this.index[id]

        try {
            if (!node.next) {
                if (node.prev && node.prev !== this.first) {
                    this.last = node.prev
                } else {
                    delete this.last
                }
            } else {
                node.next.prev = node.prev
            }

            if (!node.prev) {
                if (node.next) {
                    this.first = node.next
                    if (this.first === this.last) {
                        delete this.last
                    }
                } else {
                    delete this.first
                }
            } else {
                node.prev.next = node.next
            }

            delete node.next
            delete node.prev

            return node
        } catch (error) {
            console.error(error, `LINKED LIST ERROR:`, this.key, id)
            if (this.resetLists) {
                this.resetLists()
            }
            return node
        }
    }

    exists(id: number): boolean {
        return !!this.index[id]
    }

    has(id: number): boolean {
        return !!this.index[id]
    }

    getFirst(): LinkedListNode | undefined {
        return this.first
    }

    getLast(): LinkedListNode | undefined {
        return this.last
    }

    getPrev(id: number): LinkedListNode | undefined {
        const node = this.index[id]
        if (node && node.prev) {
            return node.prev
        }
        return this.last
    }

    getNext(id: number): LinkedListNode | undefined {
        const node = this.index[id]
        if (node && node.next) {
            return node.next
        }
        return this.first
    }

    getPrevID(id: number): number | undefined {
        const node = this.getPrev(id)
        if (node) return node.id
    }

    getNextID(id: number): number | undefined {
        const node = this.getNext(id)
        if (node) return node.id
    }

    forEach(callback: (node: LinkedListNode) => void): void {
        let next = this.first
        while (next) {
            callback(next)
            next = next.next
        }
    }

    ids(): Array<number> {
        const ids: Array<number> = []
        let next = this.first
        while (next) {
            ids.push(next.id)
            next = next.next
        }
        // console.log('this.first', this.first, this.last)
        return ids
    }

    size(): number {
        return this.ids().length
    }
}
